import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';
import * as fromAttachment from '.';
import { LoggingService } from '../shared/services/logging/logging.service';
const log = new LoggingService();

export const AttachmentRoute: Ng2StateDeclaration = {
    // TODO: will having all these here mess with lazy loading of modules?
    // https://ui-router.github.io/guide/lazyloading
    name: 'attachment',
    url: '/attachment/:fileId',
    data: { requiresAuth: true },
    resolve: [
        {
            token: 'fileId',
            deps: [Transition],
            resolveFn: fileIdResolver
        }
    ],
    component: fromAttachment.AttachmentViewFeatureComponent
};

export function fileIdResolver(t: Transition) {
    const fileId = t.params().fileId;
    log.debug({
        type: 'ViewAttachmentRoute:fileId:resolve',
        t,
        fileId
    });
    return fileId;
}
